import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiClock,
  FiSend,
} from "react-icons/fi";

const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState(null);
  const { pathname } = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: اتصال به API ارسال پیام
    setStatus("success");
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  const contactInfo = [
    {
      icon: FiMapPin,
      title: "آدرس",
      value: "همدان، کیلومتر 5 جاده کرمانشاه، روبه روی کارخانه آرد مریانج، فروشگاه کالای ساختمانی سازین.",
    },
    {
      icon: FiPhone,
      title: "تلفن همراه",
      value: "09183119682",
      href: "tel:02112345678",
    },
    {
      icon: FiMail,
      title: "ایمیل",
      value: "info@sazin-co.ir",
      href: "mailto:info@sazin-co.ir",
    },
    {
      icon: FiClock,
      title: "ساعات کاری",
      value: "شنبه تا پنجشنبه، ۹ صبح تا ۶ عصر",
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="px-4 py-6 md:px-6 md:py-8 lg:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-8">
        {/* Hero */}
        <section className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="bg-gradient-to-l from-[#1E3A5F] to-[#2B5388] px-4 py-8 text-center text-white md:px-8 md:py-12">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-[#FFC107]">
              <FiPhone className="h-3.5 w-3.5" />
              تماس با ما
            </span>

            <h1 className="mt-4 text-lg font-bold leading-8 text-white md:text-2xl lg:text-3xl">
              با ما در ارتباط باشید
            </h1>

            <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-white/80 md:text-base">
              سوالات، پیشنهادات یا انتقادات خود را با ما در میان بگذارید؛ تیم
              پشتیبانی ما در سریع‌ترین زمان پاسخگو خواهد بود.
            </p>
          </div>
        </section>

        {/* Contact Info */}
        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-100 px-4 py-4 sm:px-5">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              اطلاعات تماس
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-4 p-4 sm:p-5 md:grid-cols-2 lg:grid-cols-4">
            {contactInfo.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl border border-gray-200 bg-gray-50/60 p-4 transition-all duration-200 hover:border-[#00AFA9]/40 hover:shadow-md"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#00AFA9]/10 text-[#00AFA9]">
                  <item.icon className="h-5 w-5" />
                </span>

                <h3 className="mt-3 text-sm font-semibold text-gray-900">
                  {item.title}
                </h3>

                {item.href ? (
                  <a
                    href={item.href}
                    className="mt-1 block text-sm leading-7 text-gray-600 transition-colors hover:text-[#00AFA9]"
                  >
                    {item.value}
                  </a>
                ) : (
                  <p className="mt-1 text-sm leading-7 text-gray-600">
                    {item.value}
                  </p>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Contact Form */}
        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-100 px-4 py-4 sm:px-5">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              ارسال پیام
            </h2>
            <p className="mt-1 text-xs text-gray-500 sm:text-sm">
              فرم زیر را تکمیل کنید تا در سریع‌ترین زمان با شما تماس بگیریم.
            </p>
          </div>

          <div className="p-4 sm:p-5">
            {status === "success" && (
              <div className="mb-4 rounded-lg border border-[#00AFA9]/30 bg-[#00AFA9]/10 px-4 py-3 text-sm text-[#00938E]">
                پیام شما با موفقیت ارسال شد. با تشکر از اعتماد شما.
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div>
                  <label
                    htmlFor="name"
                    className="mb-1.5 block text-sm font-medium text-gray-700"
                  >
                    نام و نام خانوادگی
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={form.name}
                    onChange={handleChange}
                    placeholder="نام خود را وارد کنید"
                    className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-[#1E3A5F] focus:ring-2 focus:ring-[#1E3A5F]/20"
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="mb-1.5 block text-sm font-medium text-gray-700"
                  >
                    ایمیل
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={handleChange}
                    placeholder="example@email.com"
                    className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-[#1E3A5F] focus:ring-2 focus:ring-[#1E3A5F]/20"
                  />
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="mb-1.5 block text-sm font-medium text-gray-700"
                  >
                    شماره تلفن
                  </label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="0912xxxxxxx"
                    className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-[#1E3A5F] focus:ring-2 focus:ring-[#1E3A5F]/20"
                  />
                </div>

                <div>
                  <label
                    htmlFor="subject"
                    className="mb-1.5 block text-sm font-medium text-gray-700"
                  >
                    موضوع
                  </label>
                  <input
                    id="subject"
                    name="subject"
                    type="text"
                    value={form.subject || ""}
                    onChange={handleChange}
                    placeholder="موضوع پیام"
                    className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-[#1E3A5F] focus:ring-2 focus:ring-[#1E3A5F]/20"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="mb-1.5 block text-sm font-medium text-gray-700"
                >
                  پیام
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  value={form.message}
                  onChange={handleChange}
                  placeholder="متن پیام خود را بنویسید..."
                  className="w-full resize-none rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-[#1E3A5F] focus:ring-2 focus:ring-[#1E3A5F]/20"
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="inline-flex items-center gap-2 rounded-lg bg-[#1E3A5F] px-4 py-2 text-sm font-medium text-[#FFC107] transition-colors duration-200 hover:bg-[#2B5388] disabled:cursor-not-allowed disabled:opacity-50"
                >
                  ارسال پیام
                  <FiSend className="h-4 w-4" />
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
